import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { operationById } from '../../lookup';
import { MethodBadge } from '../method-badge';

/**
 * Links a guide to an endpoint page by operation id: `<EndpointLink id="addCartLine" />` shows the
 * method and path; children replace that label. An unknown id renders red so a stale guide shows.
 */
export function EndpointLink({ id, children }: { id: string; children?: ReactNode }) {
  const operation = operationById(id);
  if (!operation) {
    return (
      <code data-missing-operation={id} className="text-destructive">
        {id}
      </code>
    );
  }
  return (
    <Link
      to="/docs/api/$tag/$operation"
      params={{ tag: operation.tag, operation: operation.slug }}
      className="text-foreground decoration-primary/50 hover:decoration-primary inline-flex items-baseline gap-1.5 font-medium underline underline-offset-4"
    >
      {children ?? (
        <>
          <MethodBadge method={operation.method} size="xs" className="self-center" />
          <code className="font-mono text-[0.85em]">{operation.path}</code>
        </>
      )}
    </Link>
  );
}
